import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { authFetch } from '../../../utils/api';

const GrillSizeType = ({ value, onChange, id = 'GrillSizeType', label = 'Grill Size Type', disabled = false, appliesTo = 'windows', showNone = true }) => {
    const defaultValue = value?.value || '';
    const [selectedGrillSizeType, setSelectedGrillSizeType] = useState(defaultValue);
    const [grillSizeTypes, setGrillSizeTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch grill size types from API
    useEffect(() => {
        authFetch(`/grills/size-types?applies_to=${appliesTo}`)
            .then(data => {
                const activeTypes = data.filter(t => t.active);
                setGrillSizeTypes(activeTypes);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch grill size types:', err);
                setLoading(false);
            });
    }, []);

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedGrillSizeType(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && !selectedGrillSizeType) {
            if (showNone) {
                setSelectedGrillSizeType('None');
                onChange({ value: 'None', label: 'None' });
            } else if (grillSizeTypes.length > 0) {
                const defaultOption = grillSizeTypes[0];
                const newValue = defaultOption?.value || '';
                const newLabel = defaultOption?.label || '';
                setSelectedGrillSizeType(newValue);
                onChange({ value: newValue, label: newLabel });
            }
        }
    }, [loading, grillSizeTypes, showNone]);

    const handleGrillSizeTypeChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedGrillSizeType(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGrillSizeType}
                onChange={handleGrillSizeTypeChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    <>
                        {showNone && (
                            <option value="None">
                                {selectedGrillSizeType === 'None' ? 'None ✔' : 'None'}
                            </option>
                        )}
                        {grillSizeTypes.map(option => (
                            <option key={option.id} value={option.value}>
                                {selectedGrillSizeType === option.value ? `${option.label} ✔` : option.label}
                            </option>
                        ))}
                    </>
                )}
            </select>
        </div>
    );
};

export default GrillSizeType;
